import { useMemo, useState } from "react";
import { fetchCampaignImages } from "../helpers";
const defaultResponse = {
    data: [{ id: 0, url: "" }],
    meta: {
        total: 0, offset: 0, limit: 0, count: 0,
    },
};
const useGetCampaignAssets = (campaignId) => {
    const [loading, setLoading] = useState(false);
    const [assetData, setAssetData] = useState(defaultResponse);
    useMemo(() => fetchCampaignImages(campaignId)
        .then((response) => {
        setLoading(false);
        if (response) {
            setAssetData(response);
        }
    }), [campaignId]);
    return {
        loading,
        assetData,
    };
};
export default useGetCampaignAssets;
